import React from 'react';

import { IIconProps, TIconType } from '../interface';

import ListWhiteIcon from './ListWhiteIcon';
import CartRequestIcon from './RequestCartActiveIcon';

const RequestCartIcon: TIconType = (props?: IIconProps) => {
	return (
		<CartRequestIcon
			counter={props?.count}
			icon={ListWhiteIcon(props)}
		/>
	);
};

export default RequestCartIcon;
